import PropTypes from 'prop-types'
import {createContainer, subscribe} from '@republic/react-foundation'
import modals from '../utils/models/modals'

export default (
    createContainer(
        'ModalContainer',
        {
            propTypes: {
                shown: PropTypes.bool.isRequired
            }
        },
        subscribe(
            ({name}) => name,
            name => modals.map(modals => ({shown: !!modals[name]})),
            (state, {name, ...props}) => ({
                ...props,
                ...state
            }),
            {
                propTypes: {
                    name: PropTypes.string.isRequired
                }
            })))
